import { useState } from 'react'
import I18n from 'common/i18n'
import AuthService from 'common/services/auth'
import Input from 'components/ui/form/input'
import Button, { BlueButton } from 'components/ui/button'
import Form from 'components/ui/form'
import CircularProgress from '@mui/material/CircularProgress'
import Alert from '@mui/material/Alert'
import Box from '@mui/system/Box'
import { useToast } from 'common/services/toast/provider'

export default function ForgotPasswordForm({
  setAction
}: {
  setAction: (action: any) => void
}) {
  const [state, setState] = useState({ loading: false, error: '' })
  const [email, setEmail] = useState('')
  const { showToast } = useToast()

  const forgetPassword = async function (email: string) {
    try {
      setState((prev) => ({ ...prev, loading: true, error: '' }))
      await AuthService.forgetPassword(email)
      showToast(
        'Um e-mail com as instruções para redefinir sua senha foi enviado.',
        'success'
      )
      setTimeout(setAction, 3000)
    } catch (error: any) {
      setState((prev) => ({
        ...prev,
        error: error.message as string
      }))
    } finally {
      setState((prev) => ({ ...prev, loading: false }))
    }
  }

  return (
    <>
      {state.loading && (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
          <CircularProgress color='primary' />
        </Box>
      )}
      <Box
        sx={
          state.loading
            ? { display: 'none' }
            : {
                '@media (max-width: 430px)': {
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  width: '100%',
                  padding: 0,
                  margin: 0
                }
              }
        }
      >
        <Box
          sx={{
            '@media (max-width: 430px)': {
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              width: '100%',
              '& > *': {
                width: '100%',
                maxWidth: '320px'
              }
            }
          }}
        >
          <Form onSubmit={(formData) => {}} autocomplete={false}>
            {
              <>
                {Boolean(state.error) && (
                  <Alert
                    severity='error'
                    sx={{
                      mb: 3,
                      fontSize: {
                        xs: '0.875rem',
                        sm: '1rem'
                      }
                    }}
                  >
                    {state.error}
                  </Alert>
                )}
              </>
            }
            <Box sx={{ mb: 3 }}>
              <Input
                id='email'
                type='email'
                name='email'
                label={I18n.general.email}
                placeholder={I18n.general.email}
                required={true}
                value={email}
                onChange={(value) => setEmail(value)}
              />
            </Box>
            <Box sx={{ mb: 2 }}>
              <BlueButton
                variant={'contained'}
                sx={{
                  width: '100%',
                  fontSize: {
                    xs: '0.875rem',
                    sm: '1rem'
                  },
                  padding: {
                    xs: '10px 16px',
                    sm: '12px 24px'
                  }
                }}
                onClick={() => forgetPassword(email)}
              >
                {I18n.login.recoverPassword}
              </BlueButton>
            </Box>
            <Box>
              <Button
                variant={'text'}
                sx={{
                  width: '100%',
                  fontSize: {
                    xs: '0.75rem',
                    sm: '0.875rem'
                  },
                  padding: {
                    xs: '8px 16px',
                    sm: '10px 20px'
                  }
                }}
                onClick={setAction}
              >
                {I18n.general.back}
              </Button>
            </Box>
          </Form>
        </Box>
      </Box>
    </>
  )
}
